import { render, staticRenderFns } from "./personCentral.vue?vue&type=template&id=31b8e1e0&scoped=true&"
import script from "./personCentral.vue?vue&type=script&lang=js&"
export * from "./personCentral.vue?vue&type=script&lang=js&"
import style0 from "./personCentral.vue?vue&type=style&index=0&id=31b8e1e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8e1e0",
  null
  
)

export default component.exports